import { ChangeDetectorRef, Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';

import { IWidget, IMultiSourceMultiValueWidget, SharedPoint, SharedSeries, TagMatch, DashboardSelection, WidgetSelection, TransformConfig, } from "src/app/models/dashboard";
import * as Handlebars from 'handlebars/dist/cjs/handlebars';
import { Widget, Dashboard, TimeSeriesDetailRequest, BaseEvent, TransformDetail } from 'src/api/models'
import { DataService,FileService, TransformService } from 'src/api/services';
import { AbstractDataService } from 'src/service/data.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { HttpHeaders,HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CookieService } from "ngx-cookie-service";
import { WidgetComponent } from 'src/app/views/dashboard/widgets/widget/widget.component';
import { DashboardEventService } from '../dashboard-event.service';
import { forkJoin, of, lastValueFrom } from 'rxjs';
import { DashboardDataCacheService } from 'src/service/dashboard-data-cache.service';
import { AzureAuthService } from 'src/service/azure-auth.service';

@Component({
  template: ""
})
export abstract class MultiSourceMultiValueWidget implements OnInit, OnDestroy, IWidget {
  @Output() dashboardSelected: EventEmitter<DashboardSelection>;
  //@Output() widgetSelected: EventEmitter<WidgetSelection>;
  state:any;
  widgetComponent: WidgetComponent;
  @Input() widget: Widget;
  fullScreen: boolean = false;

  public metaDataDictionary: { [key: string]: any } = {};

  dashboard: Dashboard;
  uri: string;
  public activePolling: boolean = false;
  public config: IMultiSourceMultiValueWidget;
  points: { [uri: string]: SharedPoint; } = {};
  series: { [index: number]: SharedSeries; } = {};
  refreshTimer: any;
  timeSeriesCount: number = 0;
  availableTransforms: TransformDetail[] = [];

  ngOnInit() {
    this.widget.hidden = false;
  }

  toggleFullScreen(){
    //console.log("Going fullscreen!");
    //this.widgetSelected.emit({data:data, widget:this.widget} as WidgetSelection);
    this.fullScreen = !this.fullScreen;
  }

  getPeriod() : string {
    if (this.config.period && this.config.period.length > 0) return this.config.period;
    return this.dashboard.period;
  }

  /* abstract events */
  abstract eventTypes: string[];
  abstract timeSeriesEvent(type:string, uri: string, data: any): void;

  abstract widgetBeforeInit(): void;
  abstract widgetAfterInit(): void;
  abstract widgetDataLoaded(series: SharedSeries): void;
  abstract widgetDataLoadComplete(): void;
  abstract widgetDataLoadTimeout(): void;
  abstract widgetLiveDataLoaded(point: any): void; //todo: make this Point Event
  abstract liveDataOnly(): boolean;

  constructor(public fileService: FileService, private dataService: AbstractDataService,
    private cd: ChangeDetectorRef, public app: ApplicationConfigService,
    public cmd: CommandService, public toasterService: ToastrService,
    public http: HttpClient, public cookieService: CookieService, public data: DataService,
    public events: DashboardEventService,
    auth: AzureAuthService,
    private dashboardDataCache: DashboardDataCacheService) {
      if (auth.isDashboardEditor()){
        this.data.DataGetTransforms().subscribe(t => {
          this.availableTransforms = t;
        });
      }
  }

  ngOnDestroy(): void {
    if (this.refreshTimer){
      clearInterval(this.refreshTimer);
      console.log("Interval Cleared");
    }
  }


  async loadComplete(force: boolean) {
    var widget = <IMultiSourceMultiValueWidget><any>this.widget;
    this.config = widget;
    widget.dynamicTimeSeriesList = [];
    if (widget.timeSeriesList == null || widget.timeSeriesList.length == 0){
      console.log("No time series configured for widget");
    }
    else {
      for (let ts of widget.timeSeriesList){
        if ((this.dashboard.siteType == null || this.dashboard.siteType == "") && ts.siteUri == null && ts.tagMatches != null && ts.tagMatches.length > 0){
          // query for tag matches and populate the dashboard config

          const siteType = ts.tagMatches.find(tm => tm.tagName == "siteType");
          if (siteType){
            const tagMatches = ts.tagMatches.filter(tm => tm.tagName != "siteType" && tm.tagName != "" && tm.tagValue != "");

            var res = await this.data.DataGetTagMatches({
              customerId: this.dashboard.customerId,
              siteType: siteType.tagValue,
              max: 500,
              tagMatches: tagMatches
            }).toPromise();

            console.log("MATCHING:", res);

            // toodo: update the time series list to include all the site uris found
            for (let match of res){
              const newTs = JSON.parse(JSON.stringify(ts));
              newTs.uri = match;
              newTs.tagMatches = null;
              newTs.dynamic = true;
              widget.dynamicTimeSeriesList.push(newTs);
            }
          }
        } else {
          (ts as any).dynamic = false;
          widget.dynamicTimeSeriesList.push(ts);
        }
      }
    }

    this.widgetBeforeInit();

    // Force Angular to complete any pending updates
    this.cd.detectChanges();
    // Add a microtask delay to ensure DOM is updated
    await Promise.resolve();
    //await this.sleep(10);

    // we need to wait for all widgets to load first
    if (!this.widgetComponent.delayLoad || force){
      await this.loadData();
    }
    else{
      console.log("Widget.DelayLoad");
    }

    if (this.config.refreshInterval > 0) {
      this.refreshTimer = setInterval(async () => {
        console.log("Data Refresh");
        await this.loadData();
      },  // refresh limited to 30 seconds.
      Math.max(30, this.config.refreshInterval) * 1000);
    }
    this.widgetAfterInit();
  }

  public sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public async loadData(){
    var index = 0;
    console.log('loadData', this.config);
    if (!this.activePolling) {
      this.activePolling = true;
      try {
        if (this.config == null){
          console.log("Ignoring data load as no config found for widget");
        }
        if (this.config && this.config.dynamicTimeSeriesList?.length > 0) {
          const query: DataService.DataDashboardGetsParams = {
            customerId: this.dashboard.customerId,
            dashboardId: this.dashboard.dashboardId,
            requests: []
          };

          // register for live events between widgets
          if (this.eventTypes){
            for (let eventType of this.eventTypes){
              this.events.on(eventType, (uri, event) => {
                if (eventType == "timeTrigger"){
                  this.timeSeriesEvent(eventType, uri, event);
                } else {
                  const timeSeries = this.config.dynamicTimeSeriesList.find(ts => ts.uri === uri);
                  if (timeSeries) {
                    this.timeSeriesEvent(eventType, uri, event);
                  }
                }

              });
            }
          }

          for (let timeSeries of this.config.dynamicTimeSeriesList) {
            const tsIndex = index;

            // if a URI is not set, then used the one passed in
            if (timeSeries.uri == undefined || timeSeries.uri.trim() === "") timeSeries.uri = this.uri;

            // if there is no uri, skip attempting to grab data
            if ((timeSeries.uri == undefined || timeSeries.uri.trim() === "") && (timeSeries.tagMatches == null || timeSeries.tagMatches.length == 0)) continue;


            // if live data allowed
            if (this.dashboard.liveData && timeSeries.uri && (timeSeries.transforms == null || timeSeries.transforms.length == 0 || this.liveDashboardAllowed(timeSeries.transforms))){
              // can we load a default view of data?
              //this.widgetLiveDataLoaded({uri:timeSeries.uri, point:{value:'--.--'}});
              this.dataService.registerForLiveData(timeSeries.uri, d => {
                //var dynamicIndex = 0;
                //var ss = this.series[tsIndex];
                try {
                  this.widgetLiveDataLoaded(d);
                  this.cd.detectChanges();
                }
                catch (ee) {
                  console.log(ee);
                }
              });
            }

            //todo: build a collection of items to get
            const args: TimeSeriesDetailRequest = {
                index: index,
                period: this.getPeriod(),
                forceEmbed: timeSeries.forceEmbed,
                timeSeries: {
                  single: {
                    variable: {
                      uri: timeSeries.uri,
                      tagMatches: timeSeries.tagMatches,
                      transforms: this.getTransformConfig(timeSeries)
                    }
                  },
                  virtualTimeSeriesId: timeSeries.virtualTimeSeriesId
                },
                siteUri: timeSeries.siteUri ?? this.uri,
                siteType: this.dashboard.siteType,
                type: timeSeries.sourceType,
                timeZoneOffset: this.app.getTimeZoneOffset(this.dashboard.timeZone),
                publishedIdentifier: this.dashboard.publishedIdentifier
              };

            if (this.dashboard.liveData && this.liveDataOnly()){
              console.log(`Ignoring data load for widget ${this.widget.widgetId} due to live data configuration. Using SignalR only`);
            }
            else if (args.timeSeries.single.variable.tagMatches != null && args.timeSeries.single.variable.tagMatches.length > 0 && args.siteUri != null){
              // add a site specific query
              query.requests.push(args);
            }
            else if ((args.timeSeries.single.variable.tagMatches == null || args.timeSeries.single.variable.tagMatches.length == 0) && args.timeSeries.single.variable.uri != null){
              // add a site specific query
              args.timeSeries.single.variable.tagMatches = null;
              query.requests.push(args);
            }
            else {
              console.log("Ignoring query - invalid configuration");
            }
            index++;
          }

          if (query.requests.length > 0){
            try {
              const results = await lastValueFrom(this.dashboardDataCache.getDashboardData(query));
              this.activePolling = false;
              var tsIndex = 0;
              try {
                if (results && results.length > 0){

                  for (let res of results){
                    var dynamicIndex = 0;
                    if (res.results) {
                      if (res.results.length == 0){
                        this.widgetDataLoaded(null);
                      }
                      for (let ss of res.results){
                        try{
                          //Given we are using dynamicDisplayName I think that displayName should be nullable
                          if ((this.config.dynamicTimeSeriesList[tsIndex] as any).displayName == null || (this.config.dynamicTimeSeriesList[tsIndex] as any).displayName == ''){
                            (this.config.dynamicTimeSeriesList[tsIndex] as any).displayName = ss.name;
                          }
                          (ss as SharedSeries).index = tsIndex;
                          (ss as SharedSeries).dynamicIndex = dynamicIndex;
                          this.series[tsIndex] = ss as SharedSeries;
                          this.timeSeriesCount +=1;
                          // popupate metaData for quick lookup and setup display name if it requires dynamics parsing
                          this.metaDataDictionary[(this.config.dynamicTimeSeriesList[tsIndex] as any).displayName] = (ss as SharedSeries).metaData;
                          //(this.config.dynamicTimeSeriesList[tsIndex] as any).dynamicDisplayName = this.parseForMetaTag((this.config.dynamicTimeSeriesList[tsIndex] as any).displayName,(ss as SharedSeries));

                          if ((this.config.dynamicTimeSeriesList[tsIndex] as any).displayName && (this.config.dynamicTimeSeriesList[tsIndex] as any).displayName.includes("{")){
                            let value = (ss as SharedSeries).values.length > 0 ? (ss as SharedSeries).values[(ss as SharedSeries).values.length - 1].value : null;
                            const popupData = {
                                series: ss,
                                data: value,
                                latitude: ss.latitude,
                                longitude: ss.longitude,
                                metaData: ss.metaData
                            };
                            (this.config.dynamicTimeSeriesList[tsIndex] as any).dynamicDisplayName = this.renderTemplate((this.config.dynamicTimeSeriesList[tsIndex] as any).displayName, popupData);
                          } else if ((this.config.dynamicTimeSeriesList[tsIndex] as any).displayName) {
                            (this.config.dynamicTimeSeriesList[tsIndex] as any).dynamicDisplayName = (this.config.dynamicTimeSeriesList[tsIndex] as any).displayName;
                          } else {
                            (this.config.dynamicTimeSeriesList[tsIndex] as any).dynamicDisplayName = (ss as SharedSeries).name;
                          }


                          this.widgetDataLoaded(this.series[tsIndex]);
                          dynamicIndex = dynamicIndex + 1;
                        }
                        catch (le){
                          console.error("Error loading series data for widget", le);

                        }

                      }
                    }
                    tsIndex++;
                  }
                }
              }
              finally {
                this.widgetDataLoadComplete();
              }
              this.widget.hidden = (this.timeSeriesCount == 0);
            }
            catch (e){
              this.activePolling = false;
              console.error("Error loading widget", e)
              if (e.status == 504){
                this.widgetDataLoadTimeout();
              }
            }
          }else{
            //this.widget.hidden = true;
            this.activePolling = false;
            try{
              this.widgetDataLoaded(null);
            }
            catch(e) {
              console.error("Error loading widget", e)
            }
          }
        }
      }
      finally{

      }
    }
  }

  liveDashboardAllowed(transforms: any[]): boolean {
    for (let transform of transforms){
      const transformDetail = this.availableTransforms.find(t => t.id === transform.transform.id);
      if (transformDetail && !transformDetail.supportsLive){
        return false;
      }
    }
    return true;
  }

  public getTransformConfig(item: any): any[] {
    if (item && item.transforms && item.transforms.length > 0){
      return item.transforms;
    }
    return null;
  }

  //---- HELPERS ----//
  public parseForMetaTag(text: string | number, s?: SharedSeries, p?: SharedPoint) {
    // populate the latest point if not provided as it may contain meta data that is relevant for parsing
    if (p === null && s && s.values.length > 0) p = s.values[s.values.length - 1];

      //don't tag match if not a string
      if (!text || typeof text !== 'string') {
          //console.warn('Invalid text for meta tag parsing:', text);
          return text;
      }
      const match = text.match(/{(.+?)}/);
      if (!match) return text;

      //lookup based on display name
      if(text.includes("."))
      {
          const value = match[1].split('.').reduce((acc, part) => acc && acc[part], this.metaDataDictionary);
          //console.log(`Parsed meta tag '${text}' to value:`, value);
          if(value === undefined){
              console.warn(`Meta tag '${text}' not found in metadata dictionary.`);
              return text;
          }
          return value;
      }

      const tag = match[1];

      //check latest point
      if(p && p.metaData && Object.keys(p.metaData).length > 0 && tag in p.metaData)
      {
          const value = p.metaData[tag];
          if(value === undefined){
              console.warn(`Meta tag '${text}' not found in metadata dictionary.`);
              return text;
          }
          console.log(`Parsed meta tag '${text}' to value:`, value);
          return value;
      }


      if (s && s.metaData && Object.keys(s.metaData).length > 0 && tag in s.metaData) {

          const value = s.metaData[tag];
          console.log(`Parsed meta tag '${text}' to value:`, value);
          return value;
      }

      return text;

  }

  // Helper method to render a dynamic template with data
  public renderTemplate(template: string, data: any): string {
    // Compile and render directly with Handlebars
    try{
      const compiledTemplate = Handlebars.compile(template);
      const html = compiledTemplate(data);

      return html;
    }
    catch (e){
      console.error("Error rendering template", e);
      return template;
    }
  }
}
